<template>
  <transition
    name="modal-fade"
    appear
  >
    <div
      class="modal-container"
      @click="$emit('close', false)"
    >
      <div
        :class="['modal', { 'small-modal': smallModal }, { 'auto-width': autoWidth }]"
        @click.stop
      >
        <div class="modal-window-container">
          <div class="header">
            <div class="title">
              <slot name="title" />
            </div>
          </div>

          <div class="content">
            <slot />
          </div>
        </div>

        <button
          v-if="closeBtn"
          class="close"
          @click="$emit('close', false)"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalWindow',
  props: {
    smallModal: Boolean,
    autoWidth: Boolean,
    closeBtn: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close']
}
</script>

<style lang="scss">
.modal-container {
  background: rgba(54, 55, 64, 0.6);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    background: #FFFFFF;
    border: 1px solid #DFE0EB;
    border-radius: 8px;
    width: 90%;
    max-height: 95%;
    position: relative;
    overflow: auto;
    button.close {
      width: 2rem;
      height: 2rem;
      background: #EFEFF0;
      position: absolute;
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      right: 32px;
      top: 25px;
      transition: .3s ease;
      &::after, &::before {
        position: absolute;
        content: "";
        width: 14px;
        height: 2px;
        border-radius: 4px;
        background: #8C8C8C;
      }
      &::after {
        transform: rotate(45deg);
      }
      &::before {
        transform: rotate(-45deg);
      }
      &:hover {
        transform: scale(1.2);
        transition: .3s ease;
        box-shadow: 0 0 3px rgb(88, 88, 88);
      }
    }
    .modal-window-container {
      padding: 2rem;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      .header {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        .title {
          font-weight: 500;
          font-size: 1.5rem;
          line-height: 30px;
          letter-spacing: 0.15px;
          color: rgba(0, 0, 0, 0.87);
          mix-blend-mode: normal;
        }
      }
      .content {
        width: 100%;
        margin-top: 20px;
        height: inherit;
      }
    }
  }
  .small-modal {
    width: 40%;
    height: 370px;
  }
  .auto-width {
    width: auto;
  }
}
</style>
